// extracted by mini-css-extract-plugin
export var copyableItem = "_4b-0";
export var underlined = "_4b-1";